// @ts-nocheck
import type { PropsWithChildren } from 'react';
import { makeAc } from 'store/actions';

export enum DialogShowId {
  CUSTOM = 'custom',
  INVOICE = 'invoice',
  CONFIRM = 'confirm',
}

export enum DialogShowSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  FULL = 'full',
}

export const viewActionTypes = {
  dialog: {
    show: 'DIALOG_SHOW',
    hide: 'DIALOG_HIDE',
  },
};

export type ShowDialogOptions = PropsWithChildren<{
  id: DialogShowId;
  size?: DialogShowSize;
  keepMountOnExit?: boolean;
  title?: string;
  messages?: string;
  onClose?: Function;
}>;

type ShowDialog = (showDialogOptions: ShowDialogOptions) => {};

type DialogHide = (id: DialogShowId) => {};

export const showDialog = makeAc(viewActionTypes.dialog.show) as ShowDialog;
export const dialogHide = makeAc(viewActionTypes.dialog.hide) as DialogHide;
